import { render, staticRenderFns } from "./AtualizacaoCadastro.vue?vue&type=template&id=5c98dd99"
import script from "./AtualizacaoCadastro.vue?vue&type=script&lang=js"
export * from "./AtualizacaoCadastro.vue?vue&type=script&lang=js"
import style0 from "./AtualizacaoCadastro.vue?vue&type=style&index=0&id=5c98dd99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports